import React, { useEffect, useMemo } from 'react'
import { useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import { CloseRounded } from '@mui/icons-material'
import { Modal } from '@mui/material'
import { useFlutterwave, closePaymentModal } from 'flutterwave-react-v3'
import { sendEmail } from '../../utils/emailApi'
import { getPaymentDetails } from '../../utils/payment'
import {
  Container,
  Wrapper,
  Title,
  Desc,
  CardContainer,
  ToggleButtonGroup,
  ToggleButton,
  Divider,
  SearchInput,
  ResultsSummary,
  Pagination,
  PaginationButton,
  PageButton,
  CategoryCards,
  CategoryCard,
  CategoryCardContent,
  CategoryCardTitle,
  CategoryCardText,
  CategoryCardAction,
  CategoryBackButton,
  ProgramGrid,
  ProgramCard,
  ProgramImage,
  ProgramCardBody,
  ProgramMeta,
  ProgramTitle,
  ProgramDesc,
  ProgramCourseLink,
  ProgramCardFooter,
  ProgramButton,
  ProgramDetail,
  ProgramDetailHero,
  ProgramDetailImage,
  ProgramDetailContent,
  ProgramDetailTitle,
  ProgramDetailActions,
  ProgramInfoSection,
  ProgramSectionTitle,
  ProgramSectionText,
  ProgramSectionList,
  ProgramListLabel,
  ProgramSubsection,
  ProgramSubsectionTitle,
  ProgramBottomActions,
  ProgramCourseGrid,
  ProgramCourseItem,
  ProgramCourseNumber,
  ProgramCourseTitle,
  ProgramCourseStatus,
  ApplicationOverlay,
  ApplicationFormContainer,
  ApplicationTitle,
  ApplicationForm,
  ApplicationGrid,
  ApplicationInput,
  ApplicationSelect,
  ApplicationTextarea,
  ApplicationCheckboxLabel,
  ApplicationSubmitButton,
  NoticeOverlay,
  NoticeCard,
  NoticeIcon,
  NoticeTitle,
  NoticeMessage,
  NoticeButton,
} from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { courses } from '../../data/constants'

const COURSES_PER_PAGE = 50;

const courseTitleAliases = {
  'Practical Centrifugal Pumps Design, Operation & Maintenance': 'Practical Centrifugal Pumps Design, Operation and Maintenance',
  'Centrifugal Compressor for Petroleum, Chemical & Gas Services Industry': 'Centrifugal Compressor for Petroleum, Chemical and Gas Service Industries',
  'Control Valve Sizing': 'Control Valve Sizing and Selection',
  'PSV Sizing': 'Pressure Safety Valve Sizing Stage 1 ',
  'P&ID Development': 'P&ID Development Procedure',
  'Standard Deliverables for FEED': 'Standard Deliverable List for FEED Design',
  'Mechanical Standard Deliverables for FEED': 'Mechanical Standard Deliverable List for FEED Design',
  'Process Standard Deliverables for FEED': 'Process Standard Deliverable List for FEED Design',
  'Piping Standard Deliverables for FEED': 'Piping Standard Deliverables for FEED',
  'Control & Instrumentation Standard Deliverables for FEED': 'Control & Instrumentation Standard Deliverables for FEED',
  'Material Standard Deliverables for FEED': 'Materials Standard Deliverable List for FEED Design',
  'Mechanical Engineering': 'Mechanical Engineering (Introduction)',
  'Mechanical Basis of Design': 'Mechanical Engineering Design Basis',
  'Process Engineering': 'Process Engineering (Introduction)',
  'Process Basis of Design': 'Process Engineering Design Basis',
  'Process Drafting': 'Process Drafting Engineering (Autocad)',
  'Process Simulation': 'Process Modeling/Simulation using Aspen HYSYS',
  'Process Sizing Criteria': 'Process Sizing Criteria ',
  'Liquid, Gas & Multiphase Line Sizing': 'Line Sizing',
  'Piping Engineering': 'Piping Engineering (Introduction)',
  'Piping Basis of Design': 'Piping Engineering Design Basis',
  'Piping 3D modeling': 'PIPING 3D MODELING',
  'Pipe Stress Analysis': 'PIPE STRESS ANALYSIS',
  'Process Piping Fundamentals Codes & Standards': 'Process Piping Fundamentals, Codes and Standards',
  'SCADA Design': 'SCADA DESIGN',
  'Utility Engineering': 'Utility Engineering (Introduction)',
  'Utility Basis of Design': 'Utility Engineering Design Basis',
  'Compressed Air Utility System': 'Oil and Gas Utilities - Compressed Air System',
  'Cooling Tower & Cooling Water Circuit System': 'Oil and Gas Utilities - Cooling Tower and Cooling Water Circuits',
  'Fire-Fighting Pump & Water System': 'Oil and Gas Utilities - Fire-Fighting Pump and Water System',
  'Fresh and Caustic Units & Chemical Injection System': 'Oil and Gas Utilities - Fresh and Caustic Units & Chemical Injection System',
  'Fuel System': 'Oil and Gas Utilities - Fuel System',
  'Heat Tracing & Winterization': 'Oil and Gas Utilities - Heat Tracing and Winterizing',
  'Hot Oil & Tempered Water Circuits System': 'Oil and Gas Utilities - Hot oil and Tempered Water Circuits',
  'Loading and Unloading System': 'Oil and Gas Utilities - Loading and Unloading Facilities',
  'Water Supply & Distribution System': 'Oil and Gas Utilities - Water Supply and Distribution System',
  'Process Instrumentation & Control (Flow)': 'Process Instrumentation and Control (Flow)',
  'Process Instrumentation & Control (Level)': 'Process Instrumentation and Control (Level)',
  'Process Instrumentation & Control (Pressure)': 'Process Instrumentation and Control (Pressure)',
  'Process Instrumentation & Control (Control Valves & Accessories)': 'Process Instrumentation and Control (Control Valves & Accessories)',
  'Process Instrumentation & Control (Temperature)': 'Process Instrumentation and Control (Temperature)',
  'Refinery Valves and Accessories for Control and Safety Instrumented Systems': 'Refinery Valves and Accessories for Control and Safety Instrumented Systems Course',
  'Instrumentation Engineering': 'Instrumentation Engineering (Introduction)',
  'Instrumentation Basis of Design': 'Instrumentation Engineering Design Basis',
  'Material Selection for Turbines & Compressors': 'Material Selection for Turbine & Compressors',
  'Material Selection & corrosion Control for Oil and Gas Production System': 'Materials selection and corrosion control for oil and gas production systems',
  'Material Engineering': 'Material Engineering (Introduction)',
  'Material Basis of Design': 'Materials Engineering Design Basis',
  'MTO': 'MATERIAL TAKE-OFF (MTO)',
  'Fabrication, Installation & Erection of Piping System': 'Fabrication, Installation & Erection Procedure for Piping',
  'Steam Boilers System': 'Steam Boilers',
  'Mechanical Drafting': 'Mechanical Drafting (Equipment & Piping (AutoCAD)) Engineering',
  'Shell & Tube Heat Exchanger': 'Shell and Tube Heat Exchanger',
};

const slugifyProgram = (value) =>
  value
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const findCourseByTitle = (title) =>
  courses.find((course) => course.title.toLowerCase() === title.toLowerCase()) ||
  courses.find((course) => course.title.toLowerCase() === courseTitleAliases[title]?.toLowerCase());

const buildProgramCourses = (titles) =>
  titles.map((title) => ({
    title,
    course: findCourseByTitle(title),
  }));

const programDetails = {
  'Mechanical Engineering': {
    overview: [
      'Mechanical Engineering is the discipline responsible for the design, specification, analysis, selection, installation, operation, maintenance, and reliability of mechanical equipment used in industrial facilities.',
      'Mechanical engineers ensure that rotating and static equipment can safely and efficiently perform their intended functions throughout the facility lifecycle.',
    ],
    sections: [
      {
        title: 'Industries Where Mechanical Engineering is Applied',
        subsections: [
          { title: 'Oil and Gas', items: ['Applications:', 'Refineries', 'Gas processing plants', 'LNG facilities', 'Offshore platforms', 'Pipelines', 'Equipment:', 'Pumps', 'Compressors', 'Turbines', 'Pressure vessels', 'Heat exchangers'] },
          { title: 'Power Generation', items: ['Steam turbines', 'Gas turbines', 'Boilers', 'Condensers'] },
          { title: 'Petrochemical and Chemical Plants', items: ['Reactors', 'Storage tanks', 'Process equipment'] },
          { title: 'Water Treatment', items: ['Pumps', 'Blowers', 'Mechanical screening systems'] },
        ],
      },
      {
        title: 'Roles of a Mechanical Engineer',
        subsections: [
          { title: 'Equipment Design Engineer', items: ['Equipment specification', 'Datasheet preparation', 'Vendor document review'] },
          { title: 'Rotating Equipment Engineer', items: ['Pumps', 'Compressors', 'Turbines', 'Reliability improvement'] },
          { title: 'Static Equipment Engineer', items: ['Pressure vessels', 'Tanks', 'Heat exchangers'] },
          { title: 'Maintenance Engineer', items: ['Preventive maintenance', 'Failure analysis', 'Asset integrity'] },
          { title: 'Reliability Engineer', items: ['Root cause analysis', 'Reliability improvement programs'] },
        ],
      },
      { title: 'Major Deliverables', items: ['Equipment Datasheets', 'Mechanical Equipment List', 'Technical Bid Evaluations', 'Material Requisitions', 'Equipment Specifications', 'Vendor Data Reviews', 'Inspection Test Plans'] },
      {
        title: 'Specialized Mechanical Engineering Program',
        paragraphs: [
          "The Specialized Mechanical Engineering Program builds upon Mags Engineering Limited's commitment to developing highly skilled mechanical engineering professionals capable of supporting the design, analysis, operation, maintenance, reliability, and optimization of industrial facilities. The program integrates engineering fundamentals, industry standards, equipment design methodologies, reliability engineering principles, and practical industrial applications.",
          'The general objective of the program is to prepare professionals and technical leaders with the knowledge, skills, and competencies required to design, evaluate, operate, maintain, and optimize mechanical systems and equipment used in modern industrial facilities.',
        ],
      },
      { title: 'Specific Objectives', intro: 'The graduates will have acquired state-of-the-art knowledge and practical skills to:', items: ['Design and evaluate static and rotating equipment.', 'Perform mechanical calculations and equipment sizing.', 'Develop mechanical specifications and datasheets.', 'Analyze equipment reliability and maintainability.', 'Support FEED, detailed engineering, procurement, construction, and commissioning activities.', 'Apply international standards such as ASME, API, ISO, TEMA, and ANSI.', 'Troubleshoot mechanical equipment failures and optimize performance.', 'Lead mechanical engineering activities across industrial projects.'] },
      { title: 'Program Outcomes', intro: 'Graduates will be able to:', items: ['Design pressure vessels, heat exchangers, tanks, pumps, compressors, turbines, and packaged systems.', 'Conduct mechanical integrity and reliability assessments.', 'Support asset management and maintenance programs.', 'Improve equipment availability, safety, and operational efficiency.', 'Lead mechanical engineering projects and multidisciplinary teams.'] },
    ],
  },
  'Process Engineering': {
    overview: [
      'Process Engineering is the engineering discipline responsible for developing, designing, operating, controlling, and optimizing industrial processes that convert raw materials into valuable products safely, efficiently, economically, and sustainably.',
      'It serves as the foundation upon which mechanical, piping, electrical, instrumentation, civil, and construction engineering disciplines build their designs.',
      'Process engineers define how a plant should operate, establish process conditions, specify equipment requirements, develop operating philosophies, and ensure that production targets are achieved while maintaining safety and environmental compliance.',
    ],
    sections: [
      { title: 'Process engineering focuses on', items: ['Material and energy balances', 'Process simulation and modeling', 'Equipment sizing and specification', 'Process optimization', 'Process safety and risk management', 'Process control and automation', 'Environmental compliance', 'Energy efficiency improvement', 'Troubleshooting and debottlenecking', 'Plant commissioning and startup'] },
      {
        title: 'Industries Where Process Engineering Is Applied',
        subsections: [
          { title: 'Oil and Gas Industry', items: ['Applications:', 'Crude oil production facilities', 'Gas processing plants', 'Refineries', 'LNG plants', 'LPG recovery units', 'Offshore platforms', 'Pipeline systems', 'Petrochemical complexes', 'Typical Processes:', 'Separation', 'Distillation', 'Gas dehydration', 'Sweetening', 'Compression', 'Refrigeration', 'Flare systems'] },
          { title: 'Petrochemical Industry', items: ['Applications:', 'Ethylene plants', 'Propylene plants', 'Polymer production', 'Aromatics production', 'Solvent manufacturing', 'Products:', 'Plastics', 'Resins', 'Synthetic fibers', 'Industrial chemicals'] },
          { title: 'Chemical Industry', items: ['Applications:', 'Fertilizer production', 'Nitric acid plants', 'Sulfuric acid plants', 'Methanol plants', 'Ammonia plants', 'Specialty chemicals', 'Products:', 'Fertilizers', 'Acids', 'Solvents', 'Industrial chemicals'] },
          { title: 'Power Generation Industry', items: ['Applications:', 'Gas-fired power plants', 'Steam power plants', 'Combined cycle plants', 'Renewable energy systems', 'Process engineers optimize:', 'Heat recovery', 'Steam generation', 'Fuel consumption', 'Plant efficiency'] },
          { title: 'Water and Wastewater Treatment', items: ['Applications:', 'Desalination plants', 'Water treatment facilities', 'Wastewater treatment plants', 'Industrial effluent treatment', 'Responsibilities:', 'Treatment process design', 'Chemical dosing optimization', 'Water quality management'] },
          { title: 'Pharmaceutical Industry', items: ['Applications:', 'Drug manufacturing', 'Bioprocessing', 'Sterile production facilities', 'Focus Areas:', 'Product quality', 'Regulatory compliance', 'Batch process optimization'] },
          { title: 'Food and Beverage Industry', items: ['Applications:', 'Breweries', 'Dairy plants', 'Sugar refineries', 'Beverage manufacturing', 'Process engineers ensure:', 'Product consistency', 'Hygiene standards', 'Efficient production'] },
          { title: 'Mining and Metallurgical Industry', items: ['Applications:', 'Mineral processing plants', 'Smelters', 'Metal refining facilities', 'Activities:', 'Ore beneficiation', 'Extraction processes', 'Metallurgical optimization'] },
          { title: 'Renewable Energy Industry', items: ['Applications:', 'Hydrogen production plants', 'Green ammonia facilities', 'Biofuel plants', 'Carbon capture systems', 'Focus:', 'Sustainable production', 'Decarbonization', 'Energy transition technologies'] },
        ],
      },
      {
        title: 'Roles and Responsibilities of a Process Engineer',
        subsections: [
          { title: '1. Process Design Engineer', items: ['Responsibilities:', 'Develop Process Flow Diagrams (PFDs)', 'Develop Process and Instrumentation Diagrams (P&IDs)', 'Perform process simulations', 'Prepare process design calculations', 'Size process equipment', 'Deliverables:', 'PFD', 'P&ID', 'Equipment datasheets', 'Utility summary', 'Design basis'] },
          { title: '2. Process Safety Engineer', items: ['Responsibilities:', 'Conduct HAZOP studies', 'Conduct HAZID studies', 'Perform risk assessments', 'Develop safety philosophies', 'Support SIL assessments', 'Deliverables:', 'HAZOP reports', 'Safety requirement specifications', 'Risk assessments'] },
          { title: '3. Process Operations Engineer', items: ['Responsibilities:', 'Monitor plant performance', 'Troubleshoot operational issues', 'Improve production efficiency', 'Reduce downtime', 'Key Objectives:', 'Maximize production', 'Reduce operating costs', 'Improve reliability'] },
          { title: '4. Process Optimization Engineer', items: ['Responsibilities:', 'Debottleneck process units', 'Improve energy efficiency', 'Optimize operating conditions', 'Increase plant throughput', 'Tools Commonly Used:', 'Aspen HYSYS', 'Aspen Plus', 'AVEVA Process Optimization', 'Advanced Process Control (APC)'] },
          { title: '5. Commissioning and Startup Engineer', items: ['Responsibilities:', 'Verify design implementation', 'Support plant startup', 'Conduct performance testing', 'Resolve startup issues', 'Activities:', 'Pre-commissioning', 'Commissioning', 'Performance guarantee testing'] },
          { title: '6. Process Control Engineer', items: ['Responsibilities:', 'Develop control philosophies', 'Tune control loops', 'Improve process stability', 'Support automation projects', 'Systems:', 'DCS', 'PLC', 'SCADA', 'APC'] },
        ],
      },
      { title: 'Key Deliverables Produced by Process Engineers During FEED', items: ['Process Design Basis', 'Process Flow Diagram (PFD)', 'Utility Flow Diagram (UFD)', 'Heat and Material Balance', 'Equipment List', 'Equipment Datasheets', 'Process Simulation Model', 'Piping and Instrumentation Diagram (P&ID)', 'Cause and Effect Diagram', 'Operating Philosophy', 'Control Philosophy', 'Safeguarding Philosophy', 'Relief and Flare Reports', 'Line List', 'Utility Consumption Summary'] },
      { title: 'Essential Skills for a Process Engineer', subsections: [{ title: 'Technical Skills', items: ['Thermodynamics', 'Fluid Mechanics', 'Heat Transfer', 'Mass Transfer', 'Process Control', 'Equipment Design', 'Process Safety'] }, { title: 'Software Skills', items: ['Aspen HYSYS', 'Aspen Plus', 'AVEVA Process Simulation (PRO/II)', 'Honeywell UniSim Design', 'SLB Symmetry'] }, { title: 'Soft Skills', items: ['Problem-solving', 'Analytical thinking', 'Communication', 'Team collaboration', 'Technical report writing', 'Leadership'] }] },
      { title: 'Specialized Process Engineering Program', paragraphs: ["The Specialized Process Engineering Program builds upon Mags Engineering Limited's commitment to developing world-class engineering professionals through practical, industry-focused, and technology-driven training. The program is designed to equip engineers, technologists, plant operators, project personnel, and industry professionals with advanced process engineering knowledge and practical skills required to support the design, operation, optimization, troubleshooting, safety, and management of modern industrial facilities.", 'The program integrates engineering fundamentals, industry standards, simulation technologies, process safety principles, and real-life industrial applications to prepare participants for challenges encountered in the oil and gas, petrochemical, chemical, refining, LNG, power generation, fertilizer, renewable energy, and industrial manufacturing sectors.', 'The general objective of the program is to prepare professionals and technical leaders with the knowledge, skills, and competencies required to design, evaluate, optimize, troubleshoot, and manage process facilities in a safe, efficient, sustainable, and economically viable manner.', 'Participants will develop a comprehensive understanding of process engineering principles, engineering calculations, process simulation, equipment design, process safety, operational excellence, and digital engineering technologies that are critical to modern industrial operations.'] },
      { title: 'Program Outcomes', intro: 'Upon successful completion of the Specialized Process Engineering Program, participants will:', items: ['Demonstrate advanced technical competence in process engineering.', 'Apply engineering principles to solve complex industrial challenges.', 'Utilize modern engineering software and digital tools effectively.', 'Design, evaluate, and optimize industrial process facilities.', 'Improve plant safety, reliability, and operational efficiency.', 'Contribute to sustainable and environmentally responsible industrial development.', 'Support engineering, operations, commissioning, and project execution activities.', 'Lead technical initiatives that enhance organizational performance and competitiveness.'] },
    ],
  },
  'Piping Engineering': {
    overview: ['Piping Engineering is the discipline responsible for the design, routing, layout, stress analysis, material selection, and construction requirements of piping systems that transport fluids within industrial facilities.', 'Piping systems represent a significant portion of project capital cost and are often referred to as the "arteries" of a process plant.'],
    sections: [
      { title: 'Industries Where Piping Engineering is Applied', subsections: [{ title: 'Oil and Gas', items: ['Applications:', 'Refineries', 'LNG facilities', 'Offshore platforms', 'Gas plants'] }, { title: 'Power Plants', items: ['Steam systems', 'Cooling water systems', 'Fuel gas systems'] }, { title: 'Chemical and Petrochemical Plants', items: ['Process piping', 'Utility piping'] }] },
      { title: 'Roles of a Piping Engineer', subsections: [{ title: 'Piping Design Engineer', items: ['Pipe routing', 'Pipe support design', 'Pipe specifications'] }, { title: 'Stress Engineer', items: ['Flexibility analysis', 'Expansion studies', 'Support optimization'] }, { title: 'Layout Engineer', items: ['Equipment arrangement', 'Pipe rack development'] }, { title: 'Materials Engineer (Piping)', items: ['Pipe material selection', 'Corrosion assessment'] }] },
      { title: 'Major Deliverables', items: ['Plot Plans', 'Equipment Layouts', 'Piping General Arrangement Drawings', 'Isometric Drawings', 'Line List', 'Pipe Support Drawings', 'Stress Analysis Reports', 'Pipe Material Specifications'] },
      { title: 'Specialized Piping Engineering Program', paragraphs: ['The Specialized Piping Engineering Program is designed to develop professionals with advanced competencies in piping design, stress analysis, material selection, layout development, fabrication, installation, inspection, and maintenance of industrial piping systems.', 'The program combines engineering principles, industry standards, practical design methodologies, and modern engineering software applications to prepare participants for piping engineering roles in oil and gas, petrochemical, chemical, LNG, power, offshore, and industrial facilities.', 'The general objective of the program is to prepare professionals and technical leaders capable of designing safe, reliable, economical, and maintainable piping systems throughout the project lifecycle.'] },
      { title: 'Specific Objectives', intro: 'The graduates will have acquired advanced knowledge and skills to:', items: ['Develop piping layouts and routing philosophies.', 'Perform line sizing and hydraulic calculations.', 'Conduct piping flexibility and stress analysis.', 'Design piping support systems.', 'Select piping materials and specifications.', 'Develop piping deliverables for FEED and detailed engineering.', 'Apply ASME B31 Codes and international piping standards.', 'Support fabrication, construction, commissioning, and troubleshooting activities.'] },
      { title: 'Program Outcomes', intro: 'Graduates will be able to:', items: ['Design and analyze industrial piping systems.', 'Develop piping specifications and material classes.', 'Produce piping layouts, isometrics, and engineering deliverables.', 'Perform stress analysis and support design.', 'Improve piping system reliability, safety, and maintainability.', 'Lead piping engineering and multidisciplinary project teams.'] },
    ],
  },
  'Instrumentation Engineering': {
    overview: ['Instrumentation and Control Engineering is responsible for measuring, monitoring, controlling, automating, and safeguarding industrial processes.', 'Instrumentation engineers ensure plants operate safely, reliably, and efficiently by providing accurate process measurements and control systems.'],
    sections: [
      { title: 'Industries Where Instrumentation Engineering is Applied', subsections: [{ title: 'Oil and Gas', items: ['Applications:', 'Process control', 'Safety systems', 'Production monitoring'] }, { title: 'Power Generation', items: ['Turbine control', 'Boiler control', 'Generator protection'] }, { title: 'Chemical and Petrochemical Plants', items: ['Process automation', 'Batch control systems'] }] },
      { title: 'Roles of an Instrumentation Engineer', subsections: [{ title: 'Control Systems Engineer', items: ['DCS configuration', 'PLC programming', 'SCADA development'] }, { title: 'Instrument Engineer', items: ['Instrument specification', 'Datasheet preparation', 'Instrument selection'] }, { title: 'Functional Safety Engineer', items: ['SIL assessments', 'SIS design', 'Cause and Effect development'] }, { title: 'Automation Engineer', items: ['Process automation', 'Advanced process control'] }] },
      { title: 'Major Deliverables', items: ['Instrument Index', 'Instrument Datasheets', 'Control Philosophy', 'Cause and Effect Diagram', 'Instrument Location Plan', 'Hook-up Drawings', 'Loop Diagrams', 'Control System Architecture'] },
      { title: 'Specialized Instrumentation and Control Engineering Program', paragraphs: ['The Specialized Instrumentation and Control Engineering Program is designed to develop professionals capable of designing, implementing, operating, maintaining, and optimizing instrumentation, control, automation, and safety systems used in modern industrial facilities.', 'The program integrates measurement technologies, process control principles, automation systems, safety instrumented systems, digital technologies, and industrial applications.', 'The general objective of the program is to prepare professionals and leaders capable of delivering safe, reliable, automated, and optimized industrial operations.'] },
      { title: 'Specific Objectives', intro: 'The graduates will have acquired advanced knowledge and practical skills to:', items: ['Design instrumentation systems.', 'Select and size field instruments.', 'Design process control systems.', 'Develop control philosophies and cause-and-effect diagrams.', 'Implement distributed control systems (DCS).', 'Design safety instrumented systems (SIS).', 'Perform control valve sizing and selection.', 'Support automation and digital transformation initiatives.'] },
      { title: 'Program Outcomes', intro: 'Graduates will be able to:', items: ['Design and maintain instrumentation and control systems.', 'Improve process stability and operational efficiency.', 'Implement automation solutions.', 'Support process safety and risk reduction initiatives.', 'Perform troubleshooting and optimization of control systems.', 'Lead instrumentation and automation projects.'] },
    ],
  },
  'Utility Engineering': {
    overview: ['Utility Engineering focuses on the generation, distribution, control, and management of utility systems that support industrial processes.', 'Utilities provide the essential services required for plant operation but do not directly produce the final product.'],
    sections: [
      { title: 'Industries Where Utility Engineering is Applied', subsections: [{ title: 'Oil and Gas', items: ['Utilities Include:', 'Steam systems', 'Cooling water systems', 'Instrument air systems', 'Nitrogen systems', 'Fuel gas systems'] }, { title: 'Chemical and Petrochemical Plants', items: ['Utility distribution networks', 'Water treatment systems'] }, { title: 'Power Plants', items: ['Boiler feed water systems', 'Auxiliary systems'] }] },
      { title: 'Roles of a Utility Engineer', subsections: [{ title: 'Utility Design Engineer', items: ['Utility sizing calculations', 'Distribution network design'] }, { title: 'Utility Operations Engineer', items: ['Utility performance monitoring'] }, { title: 'Energy Engineer', items: ['Energy optimization', 'Utility consumption reduction'] }, { title: 'Water Systems Engineer', items: ['Water treatment', 'Wastewater management'] }] },
      { title: 'Major Deliverables', items: ['Utility Flow Diagrams', 'Utility Balance Reports', 'Steam System Design', 'Cooling Water Reports', 'Utility Consumption Summary', 'Utility Equipment Datasheets'] },
      { title: 'Specialized Utility Engineering Program', paragraphs: ['The Specialized Utility Engineering Program focuses on the engineering, operation, optimization, and management of utility systems that support industrial processes and facility operations.', 'The program provides comprehensive knowledge of power generation, steam systems, cooling systems, compressed air systems, fuel systems, water systems, wastewater treatment systems, and energy management technologies.', 'The general objective of the program is to prepare professionals capable of designing, operating, optimizing, and managing industrial utility systems safely, efficiently, and sustainably.'] },
      { title: 'Specific Objectives', intro: 'The graduates will have acquired advanced competencies to:', items: ['Design industrial utility systems.', 'Perform utility demand and capacity calculations.', 'Design steam generation and distribution systems.', 'Design cooling water systems.', 'Design compressed air systems.', 'Design fuel gas and utility distribution systems.', 'Optimize energy consumption.', 'Support sustainable utility management initiatives.'] },
      { title: 'Program Outcomes', intro: 'Graduates will be able to:', items: ['Design and optimize utility facilities.', 'Improve energy efficiency and sustainability.', 'Reduce utility operating costs.', 'Enhance system reliability and availability.', 'Support utility-related FEED and detailed engineering projects.', 'Lead utility engineering and energy management initiatives.'] },
    ],
  },
  'Material Engineering': {
    overview: ['Materials Engineering focuses on the selection, specification, performance, testing, degradation prevention, and lifecycle management of materials used in industrial facilities.', 'Materials engineers ensure that equipment and piping materials can withstand process conditions, corrosion, pressure, temperature, and environmental exposure.'],
    sections: [
      { title: 'Industries Where Materials Engineering is Applied', subsections: [{ title: 'Oil and Gas', items: ['Applications:', 'Corrosion management', 'Material selection', 'Integrity assessment'] }, { title: 'Petrochemical and Chemical Plants', items: ['High-temperature materials', 'Corrosion-resistant alloys'] }, { title: 'Power Generation', items: ['Boiler metallurgy', 'Turbine materials'] }, { title: 'Manufacturing', items: ['Material development', 'Failure investigations'] }] },
      { title: 'Roles of a Materials Engineer', subsections: [{ title: 'Corrosion Engineer', items: ['Corrosion studies', 'Corrosion monitoring', 'Mitigation programs'] }, { title: 'Metallurgical Engineer', items: ['Metallurgical analysis', 'Material testing', 'Failure investigations'] }, { title: 'Materials Selection Engineer', items: ['Material specification', 'Compatibility assessments'] }, { title: 'Integrity Engineer', items: ['Asset integrity management', 'Remaining life assessments'] }] },
      { title: 'Major Deliverables', items: ['Material Selection Diagrams (MSD)', 'Corrosion Studies', 'Corrosion Control Manuals', 'Material Specifications', 'Metallurgical Reports', 'Fitness-for-Service Assessments', 'Failure Investigation Reports'] },
      { title: 'Specialized Materials and Corrosion Engineering Program', paragraphs: ['The Specialized Materials and Corrosion Engineering Program is designed to develop professionals with expertise in material selection, corrosion prevention, integrity management, failure analysis, inspection technologies, and asset life-cycle management.', 'The program integrates materials science, corrosion engineering, metallurgy, inspection technologies, and industrial applications to ensure the safe and reliable operation of industrial facilities.', 'The general objective of the program is to prepare professionals capable of selecting appropriate materials, preventing material degradation, managing asset integrity, and improving facility reliability.'] },
      { title: 'Specific Objectives', intro: 'The graduates will have acquired advanced knowledge and practical skills to:', items: ['Understand material properties and behavior.', 'Select materials for industrial applications.', 'Evaluate corrosion mechanisms.', 'Develop corrosion control strategies.', 'Conduct material failure investigations.', 'Implement integrity management programs.', 'Perform fitness-for-service evaluations.', 'Apply international materials and corrosion standards.'] },
      { title: 'Program Outcomes', intro: 'Graduates will be able to:', items: ['Select suitable materials for process conditions.', 'Develop corrosion prevention and mitigation strategies.', 'Improve equipment life-cycle performance.', 'Conduct root cause failure analysis.', 'Support inspection and integrity management activities.', 'Lead materials and corrosion engineering programs.', 'Enhance facility safety, reliability, and operational performance.'] },
    ],
  },
};

const executiveProgramDetails = {
  'Mechanical Engineering': {
    overview: [
      'Mechanical Engineering is the discipline responsible for the design, specification, analysis, selection, installation, operation, maintenance, and reliability of mechanical equipment used in industrial facilities.',
      'Mechanical engineers ensure that rotating and static equipment can safely and efficiently perform their intended functions throughout the facility lifecycle.',
    ],
    sections: [
      {
        title: 'Specialized Mechanical Engineering Program',
        paragraphs: [
          "The Specialized Mechanical Engineering Program builds upon Mags Engineering Limited's commitment to developing highly skilled mechanical engineering professionals capable of supporting the design, analysis, operation, maintenance, reliability, and optimization of industrial facilities.",
          'The program integrates engineering fundamentals, industry standards, equipment design methodologies, reliability engineering principles, and practical industrial applications.',
          'The general objective of the program is to prepare professionals and technical leaders with the knowledge, skills, and competencies required to design, evaluate, operate, maintain, and optimize mechanical systems and equipment used in modern industrial facilities.',
        ],
      },
      { title: 'Specific Objectives', intro: 'The graduates will have acquired state-of-the-art knowledge and practical skills to:', items: ['Design and evaluate static and rotating equipment.', 'Perform mechanical calculations and equipment sizing.', 'Develop mechanical specifications and datasheets.', 'Analyze equipment reliability and maintainability.', 'Support FEED, detailed engineering, procurement, construction, and commissioning activities.', 'Apply international standards such as ASME, API, ISO, TEMA, and ANSI.', 'Troubleshoot mechanical equipment failures and optimize performance.', 'Lead mechanical engineering activities across industrial projects.'] },
      { title: 'Program Outcomes', intro: 'Graduates will be able to:', items: ['Design pressure vessels, heat exchangers, tanks, pumps, compressors, turbines, and packaged systems.', 'Conduct mechanical integrity and reliability assessments.', 'Support asset management and maintenance programs.', 'Improve equipment availability, safety, and operational efficiency.', 'Lead mechanical engineering projects and multidisciplinary teams.'] },
    ],
  },
  'Process Engineering': {
    overview: [
      'Process Engineering is the engineering discipline responsible for developing, designing, operating, controlling, and optimizing industrial processes that convert raw materials into valuable products safely, efficiently, economically, and sustainably.',
      'It serves as the foundation upon which mechanical, piping, electrical, instrumentation, civil, and construction engineering disciplines build their designs.',
      'Process engineers define how a plant should operate, establish process conditions, specify equipment requirements, develop operating philosophies, and ensure that production targets are achieved while maintaining safety and environmental compliance.',
    ],
    sections: [
      { title: 'Process Engineering Focus Areas', items: ['Material and energy balances', 'Process simulation and modeling', 'Equipment sizing and specification', 'Process optimization', 'Process safety and risk management', 'Process control and automation', 'Environmental compliance', 'Energy efficiency improvement', 'Troubleshooting and debottlenecking', 'Plant commissioning and startup'] },
      {
        title: 'Specialized Process Engineering Program',
        paragraphs: [
          "The Specialized Process Engineering Program builds upon Mags Engineering Limited's commitment to developing world-class engineering professionals through practical, industry-focused, and technology-driven training.",
          'The program is designed to equip engineers, technologists, plant operators, project personnel, and industry professionals with advanced process engineering knowledge and practical skills required to support the design, operation, optimization, troubleshooting, safety, and management of modern industrial facilities.',
          'The program integrates engineering fundamentals, industry standards, simulation technologies, process safety principles, and real-life industrial applications to prepare participants for challenges encountered in the oil and gas, petrochemical, chemical, refining, LNG, power generation, fertilizer, renewable energy, and industrial manufacturing sectors.',
          'The general objective of the program is to prepare professionals and technical leaders with the knowledge, skills, and competencies required to design, evaluate, optimize, troubleshoot, and manage process facilities in a safe, efficient, sustainable, and economically viable manner.',
          'Participants will develop a comprehensive understanding of process engineering principles, engineering calculations, process simulation, equipment design, process safety, operational excellence, and digital engineering technologies that are critical to modern industrial operations.',
        ],
      },
    ],
  },
  'Piping Engineering': {
    overview: [
      'Piping Engineering is the discipline responsible for the design, routing, layout, stress analysis, material selection, and construction requirements of piping systems that transport fluids within industrial facilities.',
      'Piping systems represent a significant portion of project capital cost and are often referred to as the "arteries" of a process plant.',
    ],
    sections: [
      {
        title: 'Specialized Piping Engineering Program',
        paragraphs: [
          'The Specialized Piping Engineering Program is designed to develop professionals with advanced competencies in piping design, stress analysis, material selection, layout development, fabrication, installation, inspection, and maintenance of industrial piping systems.',
          'The program combines engineering principles, industry standards, practical design methodologies, and modern engineering software applications to prepare participants for piping engineering roles in oil and gas, petrochemical, chemical, LNG, power, offshore, and industrial facilities.',
          'The general objective of the program is to prepare professionals and technical leaders capable of designing safe, reliable, economical, and maintainable piping systems throughout the project lifecycle.',
        ],
      },
      { title: 'Specific Objectives', intro: 'The graduates will have acquired advanced knowledge and skills to:', items: ['Develop piping layouts and routing philosophies.', 'Perform line sizing and hydraulic calculations.', 'Conduct piping flexibility and stress analysis.', 'Design piping support systems.', 'Select piping materials and specifications.', 'Develop piping deliverables for FEED and detailed engineering.', 'Apply ASME B31 Codes and international piping standards.', 'Support fabrication, construction, commissioning, and troubleshooting activities.'] },
      { title: 'Program Outcomes', intro: 'Graduates will be able to:', items: ['Design and analyze industrial piping systems.', 'Develop piping specifications and material classes.', 'Produce piping layouts, isometrics, and engineering deliverables.', 'Perform stress analysis and support design.', 'Improve piping system reliability, safety, and maintainability.', 'Lead piping engineering and multidisciplinary project teams.'] },
    ],
  },
  'Instrumentation Engineering': {
    overview: [
      'Instrumentation and Control Engineering is responsible for measuring, monitoring, controlling, automating, and safeguarding industrial processes.',
      'Instrumentation engineers ensure plants operate safely, reliably, and efficiently by providing accurate process measurements and control systems.',
    ],
    sections: [
      {
        title: 'Specialized Instrumentation and Control Engineering Program',
        paragraphs: [
          'The Specialized Instrumentation and Control Engineering Program is designed to develop professionals capable of designing, implementing, operating, maintaining, and optimizing instrumentation, control, automation, and safety systems used in modern industrial facilities.',
          'The program integrates measurement technologies, process control principles, automation systems, safety instrumented systems, digital technologies, and industrial applications.',
          'The general objective of the program is to prepare professionals and leaders capable of delivering safe, reliable, automated, and optimized industrial operations.',
        ],
      },
      { title: 'Specific Objectives', intro: 'The graduates will have acquired advanced knowledge and practical skills to:', items: ['Design instrumentation systems.', 'Select and size field instruments.', 'Design process control systems.', 'Develop control philosophies and cause-and-effect diagrams.', 'Implement distributed control systems (DCS).', 'Design safety instrumented systems (SIS).', 'Perform control valve sizing and selection.', 'Support automation and digital transformation initiatives.'] },
      { title: 'Program Outcomes', intro: 'Graduates will be able to:', items: ['Design and maintain instrumentation and control systems.', 'Improve process stability and operational efficiency.', 'Implement automation solutions.', 'Support process safety and risk reduction initiatives.', 'Perform troubleshooting and optimization of control systems.', 'Lead instrumentation and automation projects.'] },
    ],
  },
  'Utility Engineering': {
    overview: [
      'Utility Engineering focuses on the generation, distribution, control, and management of utility systems that support industrial processes.',
      'Utilities provide the essential services required for plant operation but do not directly produce the final product.',
    ],
    sections: [
      {
        title: 'Specialized Utility Engineering Program',
        paragraphs: [
          'The Specialized Utility Engineering Program focuses on the engineering, operation, optimization, and management of utility systems that support industrial processes and facility operations.',
          'The program provides comprehensive knowledge of power generation, steam systems, cooling systems, compressed air systems, fuel systems, water systems, wastewater treatment systems, and energy management technologies.',
          'The general objective of the program is to prepare professionals capable of designing, operating, optimizing, and managing industrial utility systems safely, efficiently, and sustainably.',
        ],
      },
      { title: 'Specific Objectives', intro: 'The graduates will have acquired advanced competencies to:', items: ['Design industrial utility systems.', 'Perform utility demand and capacity calculations.', 'Design steam generation and distribution systems.', 'Design cooling water systems.', 'Design compressed air systems.', 'Design fuel gas and utility distribution systems.', 'Optimize energy consumption.', 'Support sustainable utility management initiatives.'] },
      { title: 'Program Outcomes', intro: 'Graduates will be able to:', items: ['Design and optimize utility facilities.', 'Improve energy efficiency and sustainability.', 'Reduce utility operating costs.', 'Enhance system reliability and availability.', 'Support utility-related FEED and detailed engineering projects.', 'Lead utility engineering and energy management initiatives.'] },
    ],
  },
  'Material Engineering': {
    overview: [
      'Materials Engineering focuses on the selection, specification, performance, testing, degradation prevention, and lifecycle management of materials used in industrial facilities.',
      'Materials engineers ensure that equipment and piping materials can withstand process conditions, corrosion, pressure, temperature, and environmental exposure.',
    ],
    sections: [
      {
        title: 'Specialized Materials and Corrosion Engineering Program',
        paragraphs: [
          'The Specialized Materials and Corrosion Engineering Program is designed to develop professionals with expertise in material selection, corrosion prevention, integrity management, failure analysis, inspection technologies, and asset life-cycle management.',
          'The program integrates materials science, corrosion engineering, metallurgy, inspection technologies, and industrial applications to ensure the safe and reliable operation of industrial facilities.',
          'The general objective of the program is to prepare professionals capable of selecting appropriate materials, preventing material degradation, managing asset integrity, and improving facility reliability.',
        ],
      },
      { title: 'Specific Objectives', intro: 'The graduates will have acquired advanced knowledge and practical skills to:', items: ['Understand material properties and behavior.', 'Select materials for industrial applications.', 'Evaluate corrosion mechanisms.', 'Develop corrosion control strategies.', 'Conduct material failure investigations.', 'Implement integrity management programs.', 'Perform fitness-for-service evaluations.', 'Apply international materials and corrosion standards.'] },
      { title: 'Program Outcomes', intro: 'Graduates will be able to:', items: ['Select suitable materials for process conditions.', 'Develop corrosion prevention and mitigation strategies.', 'Improve equipment life-cycle performance.', 'Conduct root cause failure analysis.', 'Support inspection and integrity management activities.', 'Lead materials and corrosion engineering programs.', 'Enhance facility safety, reliability, and operational performance.'] },
    ],
  },
};

const getProgramClose = (programTitle) => {
  const discipline = programTitle.toLowerCase();

  return [
    {
      title: 'Vision',
      paragraphs: [
        `To develop globally competitive ${discipline} professionals capable of driving innovation, operational excellence, sustainability, and technological advancement across the energy and industrial sectors.`,
      ],
    },
    {
      title: 'Mission',
      paragraphs: [
        'To provide industry-relevant, practical, and advanced engineering training that bridges the gap between academic knowledge and industrial application while developing the next generation of engineering leaders.',
      ],
    },
    {
      title: 'Offered By',
      paragraphs: [
        'Mags Engineering Limited',
        'Engineering Excellence • Professional Development • Industrial Innovation',
      ],
    },
  ];
};

const renderProgramItems = (items = []) => {
  const groups = [];
  let currentGroup = { label: null, items: [] };

  items.forEach((item) => {
    if (item.trim().endsWith(':')) {
      if (currentGroup.label || currentGroup.items.length > 0) {
        groups.push(currentGroup);
      }
      currentGroup = { label: item, items: [] };
      return;
    }

    currentGroup.items.push(item);
  });

  if (currentGroup.label || currentGroup.items.length > 0) {
    groups.push(currentGroup);
  }

  return groups.map((group, groupIndex) => (
    <React.Fragment key={`${group.label || 'items'}-${groupIndex}`}>
      {group.label && <ProgramListLabel>{group.label}</ProgramListLabel>}
      {group.items.length > 0 && (
        <ProgramSectionList>
          {group.items.map((item, index) => (
            <li key={`${item}-${index}`}>{item}</li>
          ))}
        </ProgramSectionList>
      )}
    </React.Fragment>
  ));
};

const renderProgramSection = (section) => (
  <ProgramInfoSection key={section.title}>
    <ProgramSectionTitle>{section.title}</ProgramSectionTitle>
    {section.intro && <ProgramSectionText>{section.intro}</ProgramSectionText>}
    {section.paragraphs?.map((paragraph) => (
      <ProgramSectionText key={paragraph}>{paragraph}</ProgramSectionText>
    ))}
    {section.items && renderProgramItems(section.items)}
    {section.subsections?.map((subsection) => (
      <ProgramSubsection key={subsection.title}>
        <ProgramSubsectionTitle>{subsection.title}</ProgramSubsectionTitle>
        {subsection.paragraphs?.map((paragraph) => (
          <ProgramSectionText key={paragraph}>{paragraph}</ProgramSectionText>
        ))}
        {subsection.items && renderProgramItems(subsection.items)}
      </ProgramSubsection>
    ))}
  </ProgramInfoSection>
);

const trainingPrograms = [
  {
    title: 'Mechanical Engineering',
    duration: '3 months',
    amount: '₦1,500,000 / $2000',
    image: 'https://ik.imagekit.io/mags/courses/Mechanical%20Engineers.png',
    description: 'A discipline-focused program covering mechanical design fundamentals, drafting, 3D modeling, rotating equipment, heat exchangers, maintenance, inspection, and FEED deliverables.',
    courseTitles: [
      'Mechanical Engineering',
      'Mechanical Basis of Design',
      'Mechanical Drafting',
      'Mechanical 3D modeling',
      'Pump',
      'Practical Centrifugal Pumps Design, Operation & Maintenance',
      'Compressor',
      'Centrifugal Compressor for Petroleum, Chemical & Gas Services Industry',
      'Shell & Tube Heat Exchanger',
      'Heat Exchanger Maintenance',
      'Heat Exchanger Inspection',
      'Mechanical Standard Deliverables for FEED',
    ],
  },
  {
    title: 'Process Engineering',
    duration: '3 months',
    amount: '₦1,500,000 / $2000',
    image: 'https://ik.imagekit.io/mags/courses/Process%20Engineer.png',
    description: 'A structured process engineering program covering design basis, drafting, simulation, sizing criteria, line sizing, pump and control valve sizing, PSV sizing, P&ID development, HAZOP, HAZID, and FEED deliverables.',
    courseTitles: [
      'Process Engineering',
      'Process Basis of Design',
      'Process Drafting',
      'Process Simulation',
      'Process Sizing Criteria',
      'Liquid, Gas & Multiphase Line Sizing',
      'Pump Sizing',
      'Control Valve Sizing',
      'PSV Sizing',
      'P&ID Development',
      'HAZOP',
      'HAZID',
      'Process Standard Deliverables for FEED',
    ],
  },
  {
    title: 'Piping Engineering',
    duration: '3 months',
    amount: '₦1,500,000 / $2000',
    image: 'https://ik.imagekit.io/mags/courses/Piping%20Engineering%20(1).png',
    description: 'A piping specialization program covering piping design foundations, drafting, 3D modeling, stress analysis, codes and standards, piping engineering, oil and gas piping, joints, fabrication, erection, planning, and FEED deliverables.',
    courseTitles: [
      'Piping Engineering',
      'Piping Basis of Design',
      'Piping Drafting',
      'Piping 3D modeling',
      'Pipe Stress Analysis',
      'Process Piping Fundamentals Codes & Standards',
      'Piping Engineering',
      'Oil and Gas Piping',
      'Piping Joints',
      'Fabrication, Installation & Erection of Piping System',
      'Work Sequence for Piping Planning Design',
      'Piping Standard Deliverables for FEED',
    ],
  },
  {
    title: 'Instrumentation Engineering',
    duration: '3 months',
    amount: '₦1,500,000 / $2000',
    image: 'https://ik.imagekit.io/mags/courses/Instrumentation%20Engineering.png',
    description: 'A practical instrumentation program covering instrumentation design foundations, drafting, SCADA, process instrumentation and control for flow, level, pressure, valves, temperature, refinery control accessories, and FEED deliverables.',
    courseTitles: [
      'Instrumentation Engineering',
      'Instrumentation Basis of Design',
      'Instrumentation Drafting',
      'SCADA Design',
      'Process Instrumentation & Control (Flow)',
      'Process Instrumentation & Control (Level)',
      'Process Instrumentation & Control (Pressure)',
      'Process Instrumentation & Control (Control Valves & Accessories)',
      'Process Instrumentation & Control (Temperature)',
      'Refinery Valves and Accessories for Control and Safety Instrumented Systems',
      'Control & Instrumentation Standard Deliverables for FEED',
    ],
  },
  {
    title: 'Utility Engineering',
    duration: '3 months',
    amount: '₦1,500,000 / $2000',
    image: 'https://ik.imagekit.io/mags/courses/Utility%20Engineers.png',
    description: 'A utility systems program covering utility design foundations, compressed air, cooling water, fire-fighting water, chemical injection, fuel systems, heat tracing, hot oil, loading and unloading, steam boilers, and water distribution.',
    courseTitles: [
      'Utility Engineering',
      'Utility Basis of Design',
      'Compressed Air Utility System',
      'Cooling Tower & Cooling Water Circuit System',
      'Fire-Fighting Pump & Water System',
      'Fresh and Caustic Units & Chemical Injection System',
      'Fuel System',
      'Heat Tracing & Winterization',
      'Hot Oil & Tempered Water Circuits System',
      'Loading and Unloading System',
      'Steam Boilers System',
      'Water Supply & Distribution System',
    ],
  },
  {
    title: 'Material Engineering',
    duration: '3 months',
    amount: '₦1,500,000 / $2000',
    image: 'https://ik.imagekit.io/mags/courses/Material%20Engineer.png',
    description: 'A materials engineering program covering material design foundations, MTO, material selection for piping, separators, tanks, turbines, compressors, valves, heat exchangers, chemical piping, refinery facilities, corrosion control, and FEED deliverables.',
    courseTitles: [
      'Material Engineering',
      'Material Basis of Design',
      'MTO',
      'Material Selection for Separator & Tanks',
      'Material Selection for Turbines & Compressors',
      'Material Selection for Valves',
      'Material Selection for Heat Exchanger',
      'Material Selection for Chemical Piping',
      'Material Selection for Refinery & Associated Facilities',
      'Material Selection & corrosion Control for Oil and Gas Production System',
      'Material Standard Deliverables for FEED',
    ],
  },
].map((program) => ({
  ...program,
  courses: buildProgramCourses(program.courseTitles),
  image: program.image || buildProgramCourses(program.courseTitles).find((programCourse) => programCourse.course?.image)?.course.image || '/HeroBanner.jpg',
}));

const Projects = ({ openModal, setOpenModal, routeTrainingType = null }) => {
  const navigate = useNavigate();
  const { programSlug } = useParams();
  const [trainingType, setTrainingType] = useState(null);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [applicationOpen, setApplicationOpen] = useState(false);
  const [applicationSubmitting, setApplicationSubmitting] = useState(false);
  const [applicationNotice, setApplicationNotice] = useState(null);
  const [toggle, setToggle] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [applicationData, setApplicationData] = useState({
    fullName: '',
    email: '',
    phone: '',
    experienceLevel: '',
    goals: '',
    consent: false,
  });

  const openTrainingCategory = (category) => {
    navigate(category === 'programs' ? '/training/executive-specialization-programs' : '/training/professional-short-courses');
    setTrainingType(category);
    setSelectedProgram(null);
    setToggle('all');
    setSearchTerm('');
  };

  const closeTrainingCategory = () => {
    navigate('/training');
    setTrainingType(null);
    setSelectedProgram(null);
    setToggle('all');
    setSearchTerm('');
  };

  const openProgram = (program) => {
    navigate(`/training/executive-specialization-programs/${slugifyProgram(program.title)}`);
    setSelectedProgram(program);
    setSearchTerm('');
  };

  const closeProgram = () => {
    navigate('/training/executive-specialization-programs');
    setSelectedProgram(null);
    setApplicationOpen(false);
    setApplicationSubmitting(false);
  };

  const handleApplicationChange = (e) => {
    const { name, value, type, checked } = e.target;
    setApplicationData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const showApplicationNotice = ({ title, message, tone = 'success' }) => {
    setApplicationNotice({ title, message, tone });
  };

  const programPayment = getPaymentDetails(selectedProgram?.amount);
  const programPaymentConfig = {
    public_key: process.env.REACT_APP_FLW_PUBLIC_KEY,
    tx_ref: `program_tx_${Date.now()}`,
    amount: programPayment.amount,
    currency: programPayment.currency,
    payment_options: 'card, banktransfer, ussd',
    customer: {
      email: applicationData.email,
      name: applicationData.fullName,
      phone_number: applicationData.phone,
    },
    customizations: {
      title: `${selectedProgram?.title || 'Executive Program'} Application`,
      description: `Payment for ${selectedProgram?.title || 'Executive Program'}`,
      logo: `${window.location.origin}/LogoImg.png`,
    },
  };
  const handleProgramFlutterPayment = useFlutterwave(programPaymentConfig);

  const resetApplicationForm = () => {
    setApplicationData({
      fullName: '',
      email: '',
      phone: '',
      experienceLevel: '',
      goals: '',
      consent: false,
    });
  };

  const submitProgramApplication = async (e) => {
    e.preventDefault();
    if (!selectedProgram) return;

    setApplicationSubmitting(true);

    try {
      await sendEmail('programApplication', {
        ...applicationData,
        program: selectedProgram.title,
        duration: selectedProgram.duration,
        amount: selectedProgram.amount,
      });

      if (programPayment.isFree) {
        resetApplicationForm();
        setApplicationSubmitting(false);
        setApplicationOpen(false);
        showApplicationNotice({
          title: 'Application submitted',
          message: "Your program application has been submitted. We'll reach out to you shortly.",
        });
      } else if (!programPayment.isValid) {
        setApplicationSubmitting(false);
        showApplicationNotice({
          title: 'Payment unavailable',
          message: 'This program has an invalid payment amount. Please contact support.',
          tone: 'error',
        });
      } else {
        handleProgramFlutterPayment({
          callback: (response) => {
            console.log('Program payment response:', response);
            closePaymentModal();
            resetApplicationForm();
            setApplicationSubmitting(false);
            setApplicationOpen(false);
            showApplicationNotice({
              title: 'Payment successful',
              message: 'Your program application has been submitted successfully.',
            });
          },
          onClose: () => {
            console.log('Program payment closed');
            setApplicationSubmitting(false);
          },
        });
      }
    } catch (error) {
      console.log('Program application error:', error);
      setApplicationSubmitting(false);
      showApplicationNotice({
        title: 'Submission failed',
        message: 'Could not submit your application. Please check the form and try again.',
        tone: 'error',
      });
    }
  };

  const filteredProjects = useMemo(() => {
    const normalizedToggle = toggle.trim().toLowerCase();
    const normalizedSearch = searchTerm.trim().toLowerCase();

    return courses
      .filter((item) =>
        normalizedToggle === 'all' ||
        item.category.trim().toLowerCase() === normalizedToggle
      )
      .filter((item) =>
        item.title.toLowerCase().includes(normalizedSearch)
      );
  }, [toggle, searchTerm]);

  const filteredPrograms = useMemo(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();

    if (!normalizedSearch) return trainingPrograms;

    return trainingPrograms.filter((program) =>
      program.title.toLowerCase().includes(normalizedSearch) ||
      program.description.toLowerCase().includes(normalizedSearch) ||
      program.courses.some((course) => course.title.toLowerCase().includes(normalizedSearch))
    );
  }, [searchTerm]);

  const totalPages = Math.max(1, Math.ceil(filteredProjects.length / COURSES_PER_PAGE));
  const pageStart = (currentPage - 1) * COURSES_PER_PAGE;
  const visibleProjects = filteredProjects.slice(pageStart, pageStart + COURSES_PER_PAGE);

  useEffect(() => {
    setTrainingType(routeTrainingType);

    if (routeTrainingType === 'programs' && programSlug) {
      setSelectedProgram(
        trainingPrograms.find((program) => slugifyProgram(program.title) === programSlug) || null
      );
    } else {
      setSelectedProgram(null);
    }

    setApplicationOpen(false);
  }, [programSlug, routeTrainingType]);

  useEffect(() => {
    setCurrentPage(1);
  }, [trainingType, toggle, searchTerm]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const pageNumbers = useMemo(() => {
    const pages = [];
    const firstPage = Math.max(1, currentPage - 2);
    const lastPage = Math.min(totalPages, currentPage + 2);

    for (let page = firstPage; page <= lastPage; page += 1) {
      pages.push(page);
    }

    return pages;
  }, [currentPage, totalPages]);

  const pageTitle = selectedProgram?.title ||
    (trainingType === 'courses' ? 'Professional Short Courses' : '') ||
    (trainingType === 'programs' ? 'Executive Specialization Program' : '') ||
    'Trainings';

  const pageDescription = selectedProgram ? '' :
    (trainingType === 'courses' ? 'Explore focused, instructor-led engineering courses across process design, piping, instrumentation, safety, commissioning, project delivery, and plant operations.' : '') ||
    (trainingType === 'programs' ? 'Choose a structured 3-month specialization path and view the complete course sequence for each engineering discipline.' : '') ||
    'Here are some of the trainings we offer at Mags Engineering';

  const selectedProgramDetails = selectedProgram ? executiveProgramDetails[selectedProgram.title] || programDetails[selectedProgram.title] : null;

  return (
    <Container id="training">
      <Wrapper>
        <Title>{pageTitle}</Title>
        {pageDescription && <Desc>{pageDescription}</Desc>}

        {!trainingType && (
          <CategoryCards aria-label="Training categories">
            <CategoryCard
              type="button"
              onClick={() => openTrainingCategory('courses')}
            >
              <CategoryCardContent>
                <CategoryCardTitle>Professional Short Courses</CategoryCardTitle>
                <CategoryCardText>
                  Choose from focused, instructor-led courses built for engineers, operators, and technical professionals
                  who want to strengthen specific skills in process design, piping, instrumentation, safety, commissioning,
                  project delivery, and plant operations.
                </CategoryCardText>
              </CategoryCardContent>
              <CategoryCardAction>Explore courses</CategoryCardAction>
            </CategoryCard>
            <CategoryCard
              type="button"
              onClick={() => openTrainingCategory('programs')}
            >
              <CategoryCardContent>
                <CategoryCardTitle>Executive Specialization Program</CategoryCardTitle>
                <CategoryCardText>
                  Follow a structured 3-month specialization path that combines related courses into a deeper professional
                  program. Each track is designed for learners who want guided progression, broader coverage, and stronger
                  practical capability across a selected engineering area.
                </CategoryCardText>
              </CategoryCardContent>
              <CategoryCardAction>View programs</CategoryCardAction>
            </CategoryCard>
          </CategoryCards>
        )}

        {trainingType && (
          <CategoryBackButton
            type="button"
            onClick={selectedProgram ? closeProgram : closeTrainingCategory}
          >
            {selectedProgram ? 'Back to programs' : 'Back to training categories'}
          </CategoryBackButton>
        )}

        {trainingType === 'courses' && (
          <ToggleButtonGroup >
            {toggle === 'all' ?
              <ToggleButton active value="all" onClick={() => setToggle('all')}>All</ToggleButton>
              :
              <ToggleButton value="all" onClick={() => setToggle('all')}>All</ToggleButton>
            }
            <Divider />
            {toggle === 'mechanical' ?
              <ToggleButton active value="mechanical" onClick={() => setToggle('mechanical')}>Mechanical Engineering</ToggleButton>
              :
              <ToggleButton value="mechanical" onClick={() => setToggle('mechanical')}>Mechanical Engineering</ToggleButton>
            }
            <Divider />
            {toggle === 'process' ?
              <ToggleButton active value="process" onClick={() => setToggle('process')}>Process Engineering</ToggleButton>
              :
              <ToggleButton value="process" onClick={() => setToggle('process')}>Process Engineering</ToggleButton>
            }
            <Divider />
            {toggle === 'hazop hazid' ?
              <ToggleButton active value="hazop hazid" onClick={() => setToggle('hazop hazid')}>Oil/Gas/Chemical Safety</ToggleButton>
              :
              <ToggleButton value="hazop hazid" onClick={() => setToggle('hazop hazid')}>Oil/Gas/Chemical Safety</ToggleButton>
            }
            <Divider />
            {toggle === 'project management' ?
              <ToggleButton active value="project management" onClick={() => setToggle('project management')}>Project Management Consultancy</ToggleButton>
              :
              <ToggleButton value="project management" onClick={() => setToggle('project management')}>Project Management Consultancy</ToggleButton>
            }

            <Divider />
            {toggle === 'commissioning' ?
              <ToggleButton active value="commissioning" onClick={() => setToggle('commissioning')}>Precommissioning & Commissioning</ToggleButton>
              :
              <ToggleButton value="commissioning" onClick={() => setToggle('commissioning')}>Precommissioning & Commissioning</ToggleButton>
            }
            <Divider />
            {toggle === 'plant drafting' ?
              <ToggleButton active value="plant drafting" onClick={() => setToggle('plant drafting')}>Plant Drafting & 3D Modelling</ToggleButton>
              :
              <ToggleButton value="plant drafting" onClick={() => setToggle('plant drafting')}>Plant Drafting & 3D Modelling</ToggleButton>
            }
            <Divider />
            {toggle === 'Petroleum' ?
              <ToggleButton active value="Petroleum" onClick={() => setToggle('Petroleum')}>Petroleum & Gas Engineering</ToggleButton>
              :
              <ToggleButton value="Petroleum" onClick={() => setToggle('Petroleum')}>Petroleum & Gas Engineering</ToggleButton>
            }
            <Divider />
            {toggle === 'PAI' ?
              <ToggleButton active value="PAI" onClick={() => setToggle('PAI')}>Process Control/ Automation/ Instrumentation</ToggleButton>
              :
              <ToggleButton value="PAI" onClick={() => setToggle('PAI')}>Process Control/ Automation/ Instrumentation</ToggleButton>
            }
            <Divider />
            {toggle === 'PC' ?
              <ToggleButton active value="PC" onClick={() => setToggle('PC')}>Petrochemical Engineering/</ToggleButton>
              :
              <ToggleButton value="PC" onClick={() => setToggle('PC')}>Petrochemical Engineering</ToggleButton>
            }
          </ToggleButtonGroup>
        )}

        {trainingType && !selectedProgram && (
          <SearchInput
            type="text"
            placeholder={trainingType === 'programs' ? 'Search programs...' : 'Search courses...'}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        )}

        {trainingType === 'programs' && selectedProgram ? (
          <ProgramDetail>
            <ProgramDetailHero>
              <ProgramDetailImage src={selectedProgram.image} alt={selectedProgram.title} />
              <ProgramDetailContent>
                <ProgramDetailTitle>{selectedProgram.title}</ProgramDetailTitle>
                <ProgramDesc>
                  <b>Duration:</b> {selectedProgram.duration} &nbsp; | &nbsp;
                  <b>Amount:</b> {selectedProgram.amount || 'To be announced'}
                </ProgramDesc>
                <ProgramDesc>{selectedProgram.description}</ProgramDesc>
                <ProgramDetailActions>
                  <ProgramButton as="button" type="button" onClick={() => setApplicationOpen(true)}>
                    Apply for this program
                  </ProgramButton>
                  <ProgramButton dull as={HashLink} smooth to="/#contact">
                    Make enquiry
                  </ProgramButton>
                </ProgramDetailActions>
              </ProgramDetailContent>
            </ProgramDetailHero>

            {selectedProgramDetails?.overview?.length > 0 && (
              <ProgramInfoSection>
                <ProgramSectionTitle>{selectedProgram.title}</ProgramSectionTitle>
                {selectedProgramDetails.overview.map((paragraph) => (
                  <ProgramSectionText key={paragraph}>{paragraph}</ProgramSectionText>
                ))}
              </ProgramInfoSection>
            )}

            {selectedProgramDetails?.sections?.map(renderProgramSection)}

            <ProgramSectionTitle>Course Content</ProgramSectionTitle>
            <ProgramCourseGrid>
              {selectedProgram.courses.map((programCourse, index) => (
                <ProgramCourseItem key={programCourse.title}>
                  <ProgramCourseNumber>{String(index + 1).padStart(2, '0')}</ProgramCourseNumber>
                  <ProgramCourseTitle>{programCourse.title}</ProgramCourseTitle>
                  {programCourse.course ? (
                    <ProgramCourseLink as={Link} to={`/courses/${programCourse.course.slug}`}>
                      View course
                    </ProgramCourseLink>
                  ) : (
                    <ProgramCourseStatus>Included in program</ProgramCourseStatus>
                  )}
                </ProgramCourseItem>
              ))}
            </ProgramCourseGrid>

            {getProgramClose(selectedProgram.title).map(renderProgramSection)}

            <ProgramBottomActions>
              <ProgramButton as="button" type="button" onClick={() => setApplicationOpen(true)}>
                Apply for this program
              </ProgramButton>
              <ProgramButton dull as={HashLink} smooth to="/#contact">
                Make enquiry
              </ProgramButton>
            </ProgramBottomActions>
          </ProgramDetail>
        ) : trainingType === 'programs' ? (
          <>
            <ProgramGrid>
              {filteredPrograms.map((program) => (
                <ProgramCard type="button" key={program.title} onClick={() => openProgram(program)}>
                  <ProgramImage src={program.image} alt={program.title} />
                  <ProgramCardBody>
                    <ProgramMeta>{program.duration}</ProgramMeta>
                    <ProgramTitle>{program.title}</ProgramTitle>
                    <ProgramDesc>{program.description}</ProgramDesc>
                  </ProgramCardBody>
                  <ProgramCardFooter>
                    {/* <span>{program.courses.length} course sequence</span> */}
                    <ProgramButton as="span">Learn more</ProgramButton>
                  </ProgramCardFooter>
                </ProgramCard>
              ))}
            </ProgramGrid>
            <ResultsSummary>
              Showing {filteredPrograms.length} programs
            </ResultsSummary>
          </>
        ) : trainingType === 'courses' ? (
          <>
            <CardContainer>
              {visibleProjects
                .map((project) => (
                  <ProjectCard
                    key={project.title}
                    project={project}
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                  />
                ))}
            </CardContainer>

            <ResultsSummary>
              Showing {filteredProjects.length === 0 ? 0 : pageStart + 1}-{Math.min(pageStart + COURSES_PER_PAGE, filteredProjects.length)} of {filteredProjects.length} courses
            </ResultsSummary>

            {totalPages > 1 && (
              <Pagination aria-label="Training pagination">
                <PaginationButton
                  type="button"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((page) => Math.max(1, page - 1))}
                >
                  Previous
                </PaginationButton>

                {pageNumbers.map((page) => (
                  <PageButton
                    key={page}
                    type="button"
                    active={page === currentPage}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </PageButton>
                ))}

                <PaginationButton
                  type="button"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((page) => Math.min(totalPages, page + 1))}
                >
                  Next
                </PaginationButton>
              </Pagination>
            )}
          </>
        ) : null}

        <Modal open={applicationOpen} onClose={() => setApplicationOpen(false)}>
          <ApplicationOverlay>
            <ApplicationFormContainer>
              <CloseRounded
                style={{
                  position: 'absolute',
                  top: '14px',
                  right: '18px',
                  cursor: 'pointer',
                }}
                onClick={() => setApplicationOpen(false)}
              />
              <ApplicationTitle>Apply for {selectedProgram?.title} program</ApplicationTitle>
              <ApplicationForm onSubmit={submitProgramApplication}>
                <ApplicationGrid>
                  <ApplicationInput
                    type="text"
                    name="fullName"
                    value={applicationData.fullName}
                    onChange={handleApplicationChange}
                    placeholder="Full name"
                    required
                  />
                  <ApplicationInput
                    type="email"
                    name="email"
                    value={applicationData.email}
                    onChange={handleApplicationChange}
                    placeholder="Email address"
                    required
                  />
                  <ApplicationInput
                    type="tel"
                    name="phone"
                    value={applicationData.phone}
                    onChange={handleApplicationChange}
                    placeholder="Phone number"
                    required
                  />
                  <ApplicationSelect
                    name="experienceLevel"
                    value={applicationData.experienceLevel}
                    onChange={handleApplicationChange}
                    required
                  >
                    <option value="">Experience level</option>
                    <option value="Entry level">Entry level</option>
                    <option value="1-3 years">1-3 years</option>
                    <option value="4-7 years">4-7 years</option>
                    <option value="8+ years">8+ years</option>
                  </ApplicationSelect>
                </ApplicationGrid>
                <ApplicationTextarea
                  name="goals"
                  value={applicationData.goals}
                  onChange={handleApplicationChange}
                  placeholder="Tell us briefly what you want to achieve with this program"
                  rows={5}
                />
                <ApplicationCheckboxLabel>
                  <input
                    type="checkbox"
                    name="consent"
                    checked={applicationData.consent}
                    onChange={handleApplicationChange}
                    required
                  />
                  I agree to be contacted by Mags Engineering about this program application.
                </ApplicationCheckboxLabel>
                <ApplicationSubmitButton type="submit" disabled={applicationSubmitting}>
                  {applicationSubmitting ? 'Processing...' : 'Submit Application'}
                </ApplicationSubmitButton>
              </ApplicationForm>
            </ApplicationFormContainer>
          </ApplicationOverlay>
        </Modal>

        <Modal open={Boolean(applicationNotice)} onClose={() => setApplicationNotice(null)}>
          <NoticeOverlay>
            <NoticeCard>
              <CloseRounded
                style={{
                  position: 'absolute',
                  top: '12px',
                  right: '14px',
                  cursor: 'pointer',
                }}
                onClick={() => setApplicationNotice(null)}
              />
              <NoticeIcon tone={applicationNotice?.tone}>
                {applicationNotice?.tone === 'error' ? '!' : '✓'}
              </NoticeIcon>
              <NoticeTitle>{applicationNotice?.title}</NoticeTitle>
              <NoticeMessage>{applicationNotice?.message}</NoticeMessage>
              <NoticeButton type="button" onClick={() => setApplicationNotice(null)}>
                Continue
              </NoticeButton>
            </NoticeCard>
          </NoticeOverlay>
        </Modal>
      </Wrapper>
    </Container>
  )
}

export default Projects
